interface String {
    getFirstLetters (): string;
}

String.prototype.getFirstLetters  = function (this: string)  {
    return this
        .split(' ')
        .map(word => word[0])
        .join('');
};